import React, { useState } from "react";

const WithTextReadMore = ({text, maxCharacters= 50, color='', size='', bold=false})=>{
    const [showShortText, setShowShortText] = useState(text?.length > maxCharacters)
    const shortText = text.slice(0, maxCharacters);
    
    return(
        <div>
            <p style={{whiteSpace:'pre-wrap',color:color || '', fontSize: size || '', fontWeight: bold ? 'bold': ''}}> {showShortText ? shortText : text}</p>
            {showShortText && (<p style={{cursor:'pointer', color:'grey'}} onClick={()=> setShowShortText(false)}>Ver mas</p>)}
            
        </div>

    )
}

export default WithTextReadMore